import * as CONSTRUCTOR from '../generate';

export const rescheduledInfo = CONSTRUCTOR.FRAGMENT({
  name: 'RescheduledInfo',
  fields: `{
    created_at
    created_by
    old_starting_at
    old_ending_at
    starting_at
    ending_at
  }`,
});

export const appointment = CONSTRUCTOR.FRAGMENT({
  name: 'Appointment',
  fields: `{
    id
    company_id
    company_branch_id
    opportunity_id
    opportunity_primary_customer_id
    name
    type
    note_id
    note_message
    cancellation_reason
    status
    starting_at
    ending_at
    location
    assigned_to
    customer_ids
    meeting_url
    rescheduled {...RescheduledInfoFields}
    created_at
    created_by
    updated_at
    updated_by
    deleted_at
    deleted_by
  }`,
  fragments: [rescheduledInfo],
});

export const getAppointmentMetricsResponse = CONSTRUCTOR.FRAGMENT({
  name: 'GetAppointmentMetricsResponse',
  fields: `{
    upcoming_appointment_counts
    pending_appointment_counts
    completed_appointment_counts
    cancelled_appointment_counts
    rescheduled_appointment_counts
  }`,
});

export const customerInfo = CONSTRUCTOR.FRAGMENT({
  name: 'CustomerInfo',
  fields: `{
    id
    company_id
    type
    name
    contact_ids
    created_at
    created_by
    updated_at
    updated_by
    deleted_at
    deleted_by
  }`,
});

export const opportunity = CONSTRUCTOR.FRAGMENT({
  name: 'Opportunity',
  fields: `{
    id
    lead_id
    primary_customer_id
    customer_ids
    submission_id
    stage
    lost_reason
    cancellation_reason_id
    source
    form_id
    campaign_id
    campaign_name
    channel_id
    channel_name
    project_id
    project_name
    project_site_plan_id
    project_sales_chart_type
    unit_id
    unit_number
    unit_size
    unit_spa_value
    unit_spa_currency
    unit_status_id
    unit_status_name
    unit_status_description
    unit_layout_type
    unit_created_at
    unit_updated_at
    utm_campaign
    utm_source
    utm_medium
    utm_term
    utm_content
    assigned_to
    assigned_by
    assigned_at
    created_at
    created_by
    updated_at
    updated_by
    sr_status
    sr_source_of_finance
    sr_code
  }`,
});

export const opportunityInfo = CONSTRUCTOR.FRAGMENT({
  name: 'OpportunityInfo',
  fields: `{
    id
    lead_id
    primary_customer_id
    customer_ids
    removed_customer_ids
    submission_id
    stage
    lost_reason
    cancellation_reason_id
    source
    form_id
    campaign_id
    campaign_name
    channel_id
    channel_name
    project_id
    project_name
    project_site_plan_id
    project_sales_chart_type
    unit_id
    unit_number
    unit_size
    unit_spa_value
    unit_spa_currency
    unit_status_id
    unit_status_name
    unit_status_description
    unit_layout_type
    unit_created_at
    unit_updated_at
    utm_campaign
    utm_source
    utm_medium
    utm_term
    utm_content
    upcoming_appointment_counts
    pending_appointment_counts
    booking_id
    assigned_to
    assigned_by
    assigned_at
    company_branch_id
    created_at
    created_by
    updated_at
    updated_by
    primary_customer {...CustomerInfoFields}
    customers {...CustomerInfoFields}
    sr_status
    sr_source_of_finance
    sr_code
    sr_cancellation_reason
    sr_cancellation_type
    sr_cancellation_at
    sr_unit_selection_at
    sr_units_allocated
  }`,
  fragments: [customerInfo],
});

// GetOpportunityResponse fields fragment.
export const getOpportunityResponse = CONSTRUCTOR.FRAGMENT({
  name: 'GetOpportunityResponse',
  fields: `{
    opportunity {...OpportunityInfoFields}
  }`,
  fragments: [opportunityInfo],
});

// ListOpportunitiesResponse fields fragment.
export const listOpportunitiesResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ListOpportunitiesResponse',
  fields: `{
    opportunities {...OpportunityInfoFields}
    count
    pit_id
    search_afters
  }`,
  fragments: [opportunityInfo],
});

// The purchaser-contact snapshot refs the backend stamps onto a Vietnamese booking
// at paid_verified. Deliberately NOT added to `opportunityInfo` above: that fragment is spread
// by getOpportunityResponse AND listOpportunitiesResponse, and AppSync rejects the WHOLE
// operation with FieldUndefined when a selected field is not in the deployed schema. In its
// own document, an environment whose opportunity-api schema lags loses only the snapshot
// refs — the booking page then reads the live contact, which is exactly the pre-snapshot
// behaviour. Fold these into opportunityInfo and delete this pair once the schema is deployed
// everywhere.
// Only the two fields the screen resolves on. source_contact_id and frozen_at exist on the
// type but nothing here reads them; select them when something does.
export const snapshotContactRef = CONSTRUCTOR.FRAGMENT({
  name: 'SnapshotContactRefInfo',
  fields: `{
    customer_id
    snapshot_contact_id
  }`,
});

export const getOpportunitySnapshotResponse = CONSTRUCTOR.FRAGMENT({
  name: 'GetOpportunityResponse',
  fragmentName: 'GetOpportunitySnapshotResponseFields',
  fields: `{
    opportunity {
      id
      snapshot_frozen_at
      snapshot_contacts {...SnapshotContactRefInfoFields}
    }
  }`,
  fragments: [snapshotContactRef],
});
